<payee-popup
  [onCancel]="onCancel"
  [width]="dialogWidth"
>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="notification-preview-title">{{ data.subject }}</h1>
  </ng-template>

  <div class="dialog-content">
    <div
      class="preview-layout"
      [class.preview-layout--with-sidebar]="hasSidebar"
    >
      <div class="preview-frame">
        @if (previewLoading) {
          <div class="preview-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        } @else if (previewUrl) {
          <iframe
            class="preview-iframe"
            [title]="data.subject"
            [src]="previewUrl"
          ></iframe>
        } @else {
          <p class="preview-unavailable">
            {{ "CASE_EVENTS.NOTIFICATION_PREVIEW.NO_PREVIEW" | translate }}
          </p>
        }
      </div>

      @if (hasSidebar) {
        <aside class="preview-sidebar">
          @if (data.attachments.length > 0) {
            <section class="preview-sidebar-section">
              <div class="preview-sidebar-label">
                @if (data.attachments.length === 1) {
                  {{ "CASE_EVENTS.ATTACHMENT" | translate }}
                } @else {
                  {{ "CASE_EVENTS.ATTACHMENTS" | translate }}
                }
              </div>
              @for (attachment of data.attachments; track attachment.id) {
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  class="preview-attachment-link"
                  color="blue-king"
                  [href]="attachmentUrl(attachment)"
                >
                  <payee-icon
                    class="preview-attachment-icon"
                    name="attachment"
                    height="15px"
                  ></payee-icon>
                  <span>{{ attachment.file_name }}</span>
                </a>
              }
            </section>
          }

          @if (data.routes.length > 0) {
            <section class="preview-sidebar-section">
              <div class="preview-sidebar-label">
                @if (data.routes.length === 1) {
                  {{ "CASE_EVENTS.NOTIFICATION_PREVIEW.RECIPIENT" | translate }}
                } @else {
                  {{ "CASE_EVENTS.NOTIFICATION_PREVIEW.RECIPIENTS" | translate }}
                }
              </div>
              <ul class="preview-recipients">
                @for (route of data.routes; track $index) {
                  <li>{{ route }}</li>
                }
              </ul>
            </section>
          }
        </aside>
      }
    </div>
  </div>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [mat-dialog-close]="false"
    >
      {{ "CASE_EVENTS.NOTIFICATION_PREVIEW.CLOSE" | translate }}
    </button>
  </ng-template>
</payee-popup>
